// ContactUs.jsx

import React from "react";
import "./ContactUs.css";

const ContactUs = () => {
  return (
    <div className="contact-page">

      {/* HERO SECTION */}
      <section className="contact-hero">

        <div className="contact-overlay"></div>

        <div className="contact-hero-content">
          <h1>Contact Vetrieq Global Exports</h1>

          <p>
            We are always ready to assist you with product inquiries,
            export solutions, global partnerships, and business support.
          </p>
        </div>

      </section>

      {/* CONTACT CONTENT */}
      <div className="contact-container">

        {/* LEFT SIDE */}
        <section className="contact-info">

          <div className="contact-card">
            <span>📞</span>

            <div>
              <h3>Phone / WhatsApp</h3>
              <p>(+91) 9555264537</p>
            </div>
          </div>

          <div className="contact-card">
            <span>📧</span>

            <div>
              <h3>Email Address</h3>
              <p>info@vetrieq.com</p>
            </div>
          </div>

          <div className="contact-card">
            <span>📍</span>

            <div>
              <h3>Office Address</h3>
              <p>
                Villivakkam, Chennai,
                Tamil Nadu, India - 600049
              </p>
            </div>
          </div>

          <div className="contact-card">
            <span>🕒</span>

            <div>
              <h3>Business Hours</h3>
              <p>
                Monday - Friday : 9 AM - 6 PM
                <br />
                Saturday - Sunday : 10 AM - 4 PM
              </p>
            </div>
          </div>

          {/* SOCIAL LINKS */}
          <div className="contact-social">

            <h2>Follow Us</h2>

            <div className="social-grid">

              <a
                href="https://www.linkedin.com/in/Vetrieq-global-b03333388"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn
              </a>

              <a
                href="https://x.com/Vetrieq_global"
                target="_blank"
                rel="noopener noreferrer"
              >
                Twitter
              </a>

              <a
                href="https://www.instagram.com/Vetrieq.global?igsh=YXI0eGRubzd2MHps"
                target="_blank"
                rel="noopener noreferrer"
              >
                Instagram
              </a>

              <a
                href="https://www.facebook.com/share/1BuyBXjSDe/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
              >
                Facebook
              </a>

              <a
                href="https://youtube.com/@Vetrieq?si=xR0871rzcXk8VI_v"
                target="_blank"
                rel="noopener noreferrer"
              >
                YouTube
              </a>

            </div>

          </div>

        </section>

        {/* RIGHT SIDE */}
        <section className="contact-map-section">

          <div className="map-heading">
            <h2>Find Us On The Map</h2>

            <p>
              Visit our office in Chennai and connect with our export team.
            </p>
          </div>

          <div className="map-container">

            <iframe
              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d126312.61342542966!2d80.16377445305998!3d13.082680299999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a526604fc5f92db%3A0x6c3a7d16057c5dfc!2sChennai%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1635152284063!5m2!1sen!2sin"
              allowFullScreen=""
              loading="lazy"
            ></iframe>

          </div>

        </section>

      </div>

    </div>
  );
};

export default ContactUs;